"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarGraphComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var chart_js_1 = require("chart.js");
var react_chartjs_2_1 = require("react-chartjs-2");
var doshx_controls_web_1 = require("doshx_controls_web");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_redux_1 = require("react-redux");
var colors_config_1 = __importDefault(require("../../colors.config"));
chart_js_1.Chart.register(chart_js_1.CategoryScale, chart_js_1.LinearScale, chart_js_1.BarElement, chart_js_1.Title, chart_js_1.Tooltip);
var BarGraphComponent = function (props) {
    var title = props.title, backgroundColor = props.backgroundColor, belowBadgeValue = props.belowBadgeValue;
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.dashboardState; }), orderStatusGrouping = _a.orderStatusGrouping, parcelStatusGrouping = _a.parcelStatusGrouping;
    var data = {
        labels: title === "Orders" ? orderStatusGrouping === null || orderStatusGrouping === void 0 ? void 0 : orderStatusGrouping.map(function (row) { return row.status; }) : parcelStatusGrouping === null || parcelStatusGrouping === void 0 ? void 0 : parcelStatusGrouping.map(function (row) { return row.status; }),
        datasets: [
            {
                data: title === "Orders" ? orderStatusGrouping === null || orderStatusGrouping === void 0 ? void 0 : orderStatusGrouping.map(function (row) { return row.count; }) : parcelStatusGrouping === null || parcelStatusGrouping === void 0 ? void 0 : parcelStatusGrouping.map(function (row) { return row.count; }),
                backgroundColor: backgroundColor,
                borderColor: colors_config_1.default.borders,
                borderWidth: 2,
                borderRadius: 10,
                barThickness: 100,
                categoryPercentage: 10,
            },
        ],
    };
    var options = {
        type: "bar",
        data: data,
        responsive: true,
        options: {
            scales: {
                y: {
                    beginAtZero: true,
                },
            },
        },
        plugins: {
            legend: {
                display: false,
            },
        },
    };
    return ((0, jsx_runtime_1.jsxs)(doshx_controls_web_1.BoxControl, __assign({ variant: "filled", backgroundColor: "bg-white", className: "flex flex-col h-full border-transparent rounded-lg" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-row gap-4 items-center justify-between" }, { children: (0, jsx_runtime_1.jsx)("h1", __assign({ className: "font-bold pb-2" }, { children: title })) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "mb-0 items-center flex flex-col" }, { children: [!(orderStatusGrouping === null || orderStatusGrouping === void 0 ? void 0 : orderStatusGrouping.length) ? (0, jsx_runtime_1.jsx)(doshx_controls_web_1.CircularLoaderControl, { size: "medium" }) : (0, jsx_runtime_1.jsx)(react_chartjs_2_1.Bar, { options: options, data: data }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "w-64 flex items-center justify-center mt-2" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.BadgeControl, { icon: pro_solid_svg_icons_1.faExclamationCircle, value: belowBadgeValue, colors: { backgroundColor: "bg-purple-100", iconColor: "text-purple-500" } }) }))] }))] })));
};
exports.BarGraphComponent = BarGraphComponent;
